import { render } from "./StudentModules.vue?vue&type=template&id=023883a2&scoped=true"
import script from "./StudentModules.vue?vue&type=script&lang=js"
export * from "./StudentModules.vue?vue&type=script&lang=js"

import "./StudentModules.vue?vue&type=style&index=0&id=023883a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023883a2"]])

export default __exports__